<template>
  <confirmation-dialog :action="remove" confirm-text="Удалить" confirm-btn-variant="accent">
    <template v-if="slots.activator" #activator>
      <slot name="activator" />
    </template>
    <div class="h3 mb-6">Удаление пользователя</div>
    <p class="paragraph-l">Пользователь {{ userName }} будет удалён из пространства.</p>
  </confirmation-dialog>
</template>

<script setup lang="ts">
import { toRef } from 'vue';
import ConfirmationDialog from '@/core/components/modals/ConfirmationDialog.vue';
import { useUsersStore } from '@/parts/users/store/users';

const props = defineProps<{
  userInfo: {
    id: string;
    name: string;
    lastName: string;
    middleName: string | null | undefined;
  };
}>();

const emit = defineEmits<{
  (action: 'deleted'): void;
}>();

const slots = defineSlots<{
  activator?: (props: unknown) => void;
}>();

const { deleteUser } = useUsersStore();

const remove = async () => {
  const result = await deleteUser(props.userInfo.id);

  if (!result?.errors) {
    emit('deleted');
  }
};

const userName = toRef(() => {
  return `${props.userInfo.lastName} ${props.userInfo.name} ${props.userInfo.middleName || ''}`;
});
</script>

<style scoped lang="scss"></style>
